import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVerified = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 25,
	viewBox: "0 0 25 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M11.8086 0.778752C12.1941 0.407083 12.8059 0.407083 13.1914 0.778752L15.2234 2.73794C15.4438 2.95047 15.7504 3.04973 16.054 3.00692L18.8535 2.61229C19.3845 2.53743 19.8795 2.89582 19.9721 3.42233L20.4606 6.19773C20.5136 6.49881 20.703 6.75867 20.974 6.90194L23.4715 8.2226C23.9453 8.47314 24.1343 9.05302 23.8988 9.53327L22.6571 12.0648C22.5224 12.3394 22.5224 12.6606 22.6571 12.9352L23.8988 15.4667C24.1343 15.947 23.9453 16.5269 23.4715 16.7774L20.974 18.0981C20.703 18.2413 20.5136 18.5012 20.4606 18.8023L19.9721 21.5777C19.8795 22.1042 19.3845 22.4626 18.8535 22.3877L16.054 21.9931C15.7504 21.9503 15.4438 22.0495 15.2234 22.2621L13.1914 24.2212C12.8059 24.5929 12.1941 24.5929 11.8086 24.2212L9.77659 22.2621C9.55615 22.0495 9.24964 21.9503 8.94595 21.9931L6.14654 22.3877C5.61548 22.4626 5.12053 22.1042 5.02787 21.5777L4.53938 18.8023C4.48639 18.5012 4.29695 18.2413 4.02602 18.0981L1.52851 16.7774C1.05472 16.5269 0.865666 15.947 1.10121 15.4667L2.34286 12.9352C2.47755 12.6606 2.47755 12.3394 2.34286 12.0648L1.10121 9.53327C0.865666 9.05302 1.05472 8.47314 1.52851 8.2226L4.02602 6.90194C4.29695 6.75867 4.48639 6.49881 4.53938 6.19773L5.02787 3.42233C5.12053 2.89582 5.61548 2.53743 6.14654 2.61229L8.94595 3.00692C9.24964 3.04973 9.55615 2.95047 9.77659 2.73794L11.8086 0.778752Z",
		fill: "#9565FD"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M8.5 13L11 15.5L16.5 10",
		stroke: "white",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgVerified;
